export { default } from "./CategoriesItem-component";
